import React from 'react';
import {
  SkeletonProfileImage,
  SkeletonImage,
  SkeletonBody,
  SkeletonButton,
} from '@xingternal/skeleton';
import cx from 'classnames';
import { CompanyCardContainer } from '@/components/CompanyCardContainer';
import styles from './Skeleton.css';

const CompanyCardSkeletonLoggedin: React.FC = () => (
  <div
    data-testid="skeleton-logged-in"
    className={cx(styles.skeletonWrapperLoggedIn, styles.skeletonWrapper)}
  >
    <div>
      <div className={styles.relative}>
        <SkeletonImage
          size="large"
          height="140px"
          className={styles.skeletonImage}
        />
        <div className={styles.absolute}>
          <SkeletonProfileImage variant="primary" size="large" />
        </div>
      </div>
      <div className={styles.skeletonProfileInfo}>
        <SkeletonBody variant="primary" amountRows={2} />
      </div>
    </div>
    <SkeletonButton className={styles.skeletonButton} />
  </div>
);

const CompanyCardsSkeletonLoggedin = () => (
  <CompanyCardContainer dataTestId="loggedin-skeleton-row">
    <CompanyCardSkeletonLoggedin />
    <CompanyCardSkeletonLoggedin />
    <CompanyCardSkeletonLoggedin />
  </CompanyCardContainer>
);
export { CompanyCardsSkeletonLoggedin };
